import { ERROR_SEVERITY, SUCCESS_SEVERITY } from '@glass/common/modules/constants/severities';
import setAppLoadingAction from '@glass/web/modules/app/setAppLoadingAction';
import queueGlobalSnackbarAction from '@glass/web/modules/globalSnackbar/queueGlobalSnackbarAction';

import openConfirmationDialogAction from '@glass/shared/modules/globalDialog/openConfirmationDialogAction';
import removeResumeAction from '@glass/shared/modules/resumes/actions/removeResumeAction';
import deleteResumeMutation from '@glass/shared/modules/resumes/queries/deleteResume.graphql';
import tracking from '@glass/shared/modules/tracking';

const deleteResumeAction =
  ({ resumeId, onConfirm, onUpdate }) =>
  (dispatch, getStore, { client }) =>
    new Promise((resolve, reject) => {
      try {
        dispatch(
          openConfirmationDialogAction({
            title: 'Delete $(resumeWords.singular)?',
            confirmText: 'Delete',
            message: 'Are you sure you want to permanently delete this $(resumeWords.singular)?',
            onCancel: () => reject(new Error('canceled')),
            onConfirm: async () => {
              if (typeof onConfirm === 'function') {
                await Promise.resolve(onConfirm());
              }
              dispatch(setAppLoadingAction());
              return client
                .mutate({
                  mutation: deleteResumeMutation,
                  variables: { id: resumeId },
                  update: (cache, { data: { deleteResume } }) => {
                    if (typeof onUpdate === 'function') {
                      onUpdate();
                    }
                    cache.evict({ id: cache.identify(deleteResume) });
                    cache.gc();
                  },
                })
                .then(({ data }) => {
                  dispatch(setAppLoadingAction(false));
                  dispatch(removeResumeAction(resumeId));
                  dispatch(
                    queueGlobalSnackbarAction({
                      severity: SUCCESS_SEVERITY,
                      title: 'Your $(resumeWords.abbreviated) has been deleted',
                    }),
                  );
                  return resolve(data.deleteResume);
                });
            },
          }),
        );
      } catch (err) {
        tracking.exception(err);
        dispatch(setAppLoadingAction(false));
        dispatch(
          queueGlobalSnackbarAction({
            severity: ERROR_SEVERITY,
          }),
        );
        reject(err);
      }
    });

export default deleteResumeAction;
